// Helper script to allow the desktop version of the search modal to auto focus on the input field when clicked 

document.addEventListener('DOMContentLoaded', function() {
    document.body.addEventListener('click', function(event) {
        if (event.target.closest('.header__utility a.body.flex.header__utility-search')) {
            // console.log('Trigger clicked.');

            setTimeout(function() {
                var inputField = document.querySelector('.header__utility input#Search-Header-In-Template');
                if (!inputField) {
                    // console.log('Input field not found.');
                    return; 
                }

                inputField.focus();
                // console.log('Input field focused.');

            }, 300); // time to ensure it works with the modal's animation timing
        }
    });
});